/** Reserve each aligned source/reading cell, then enough space for the longest gloss. */
const wordMetrics = (readingWidths: number[], sourceWidths: number[], glossWidths: number[], spacing: number) => {
    const contentWidth = readingWidths.reduce((total, width, index) => (
        total + Math.max(width, sourceWidths[index] || 0) + spacing
    ), 0);
    const width = Math.max(contentWidth, ...glossWidths.map((gloss) => gloss + spacing));
    return { width, contentWidth, inset: (width - contentWidth) / 2 };
};

export default wordMetrics;
